module.exports = __webpack_public_path__ + "static/media/dumbbell-hold-transparent.e2d81307.png";